import React from 'react';
import { CtaButton } from './CtaButton';
type SectionCtaProps = {
  headline: string;
  label?: string;
};
export function SectionCta({
  headline,
  label = 'Get the Anti-Refinement System™'
}: SectionCtaProps) {
  return <div className="mx-auto mt-10 w-full max-w-md rounded-3xl border border-lime/25 bg-lime/[0.06] p-5 sm:p-6" data-id="element-215" data-mp="3icng9tno0hxx">
      <p className="mb-4 text-center text-sm font-semibold leading-snug text-white/85 sm:text-base" data-id="element-216" data-mp="3nayro8tlz0i9">
        {headline}
      </p>
      <CtaButton label={label} sub="Instant download · Lifetime access · $27 USD" data-id="element-217" data-mp="38lsueqebzkd0" />
    </div>;
}